import { escapeRegExp } from "@tellescope/utils";

export interface ExistingFilesMdbFilterArgs {
  enduserId: string;
  excludedSecureNames?: string[];
  validFileTypes?: string[];
}

/**
 * Builds the `mdbFilter` for the existing-file picker.
 *
 * Every condition is expressed server-side so the picker paginates over files it can actually offer,
 * rather than fetching a page and discarding most of it client-side.
 *
 * `type` is matched with a case-insensitive `$regex` because the configured types are substrings
 * rather than full MIME types, and because the field is optional on the model — integrations may not
 * sync it. A typeless file cannot be shown to satisfy a type restriction, so `$regex` correctly
 * excludes it whenever `validFileTypes` is non-empty.
 */
export const buildExistingFilesMdbFilter = ({
  enduserId,
  excludedSecureNames,
  validFileTypes,
}: ExistingFilesMdbFilterArgs): Record<string, unknown> => ({
  enduserId,
  // Only uploads the server confirmed are downloadable; an unconfirmed row has no usable object.
  confirmedAt: { $exists: true, $nin: [null, ""] },
  secureName: { $nin: excludedSecureNames ?? [] },
  ...(validFileTypes?.length ? { type: { $regex: validFileTypes.map(escapeRegExp).join("|"), $options: "i" } } : {}),
});
